import * as React from "react";
import './VideoPlayerHeader.scss';

import swapLogo from '../../../assets/icons/swap.svg';

const VideoPlayerHeader = props => (
	<div className="videoPlayerHeader">
		<span className={`videoPlayerHeader__videoName`}>
			{props.videoName}
		</span>
		<span className={`videoPlayerHeader__videoInfo`}>
			{props.videoWidth}x{props.videoHeight} {props.videoFps}fps
		</span>

		<div className={`videoPlayerHeader__swapIconWrapper`}>
			<img
				src={swapLogo}
				alt={`swp`}
				className={`videoPlayerHeader__swapIcon`}
				onClick={props.toggleIsSwapMenuOpen}
			/>
			<span className={`videoPlayerHeader__swapText`}>
				Swap
			</span>
		</div>
	</div>
);

export default VideoPlayerHeader;